import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["current"];

  connect() {
    if (!this.hasCurrentTarget) return;
    this.element.scrollLeft = this.currentTarget.offsetLeft - this.element.firstElementChild.offsetLeft;
  }
}
